import { getDoc, onSnapshot, orderBy, query, serverTimestamp, setDoc } from "firebase/firestore";
import { leagueCollection, leagueCollections, leagueDocument } from "./leagueRepository";
import { buildStandings } from "./pointsEngine";
import { calculateFixtureStandings } from "./resultsService";

export function subscribeSeasonHistory(orgId, onValue, onError) {
  const seasons = query(leagueCollection(orgId, leagueCollections.seasons), orderBy("createdAt", "desc"));
  return onSnapshot(seasons, (snapshot) => {
    onValue(snapshot.docs.map((item) => ({ id: item.id, ...item.data() })));
  }, onError);
}

export async function archiveSeason(orgId, season, clubs, fixtures) {
  if (!season?.id) throw new Error("A season is required before it can be archived.");
  const completeFixtures = fixtures.filter((fixture) => fixture.seasonId === season.id && fixture.homeScore != null && fixture.awayScore != null);
  if (!completeFixtures.length) throw new Error("Complete at least one fixture before archiving this season.");

  const calculated = calculateFixtureStandings(clubs, completeFixtures);
  const mergedClubs = clubs.map((club) => ({ ...club, ...(calculated.find((entry) => entry.id === club.id) || {}) }));
  const finalStandings = buildStandings(mergedClubs, season).map((club, index) => ({
    id: club.id,
    name: club.name,
    badge: club.badge || club.name?.charAt(0) || "M",
    position: index + 1,
    played: club.played || 0,
    won: club.won || 0,
    drawn: club.drawn || 0,
    lost: club.lost || 0,
    goalsFor: club.goalsFor || 0,
    goalsAgainst: club.goalsAgainst || 0,
    goalDifference: club.goalDifference || 0,
    operationalPoints: club.operationalPoints || 0,
    points: club.points || 0,
  }));

  const champion = finalStandings[0] || null;
  const payload = {
    ...season,
    status: "archived",
    finalStandings,
    champion: champion ? { id: champion.id, name: champion.name, badge: champion.badge } : null,
    completedFixtures: completeFixtures.length,
    archivedAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };
  await setDoc(leagueDocument(orgId, leagueCollections.seasons, season.id), payload, { merge: true });
  return payload;
}

export async function getArchivedSeason(orgId, seasonId) {
  const snap = await getDoc(leagueDocument(orgId, leagueCollections.seasons, seasonId));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}
